// This is a very crucial function
// It is written using pre ES6 syntax
(function() {
  function checkoutBtnForwarder() {
    var shopifyBtnContainer = document.getElementsByClassName('cart-checkout')[0];
    var shopifyBtn = shopifyBtnContainer.getElementsByClassName('button--cart')[0];
    var newBtn = document.getElementsByClassName('cart-row-checkout')[0];

    newBtn.addEventListener('click', function() {
      shopifyBtn.click();
    });
  }

  setTimeout(checkoutBtnForwarder, 1000);
})();

/*
 let timeoutLimit = 3000;
  var checkoutButton = document.getElementById("checkout-button");
  const checkoutContainer = document.getElementById('checkout-container');

      checkoutButton.classList.add("disabled");
  checkoutContainer.classList.add('waiting');
      checkoutButton.disabled = true;
      setTimeout(function() {
          checkoutButton.classList.remove("disabled");
         checkoutContainer.classList.remove('waiting');
          checkoutButton.disabled = false;
      }, timeoutLimit)


function toggleCheckoutDisabled() {
  const checkoutButtonTwo = document.getElementById('checkout-button');
  const checkoutContainer = document.getElementById('checkout-container');
  
  checkoutButtonTwo.disabled = true;
  checkoutButtonTwo.classList.toggle('disabled'); 
  checkoutContainer.classList.toggle('waiting');
   setTimeout(() => {
    checkoutButtonTwo.classList.remove('disabled');
    checkoutContainer.classList.remove('waiting');
    checkoutButtonTwo.disabled = false;
  }, 3000);
}
*/

(() => {
  const calculateSubTotal = () => {
    const priceNodes = [...document.querySelectorAll('.cart__total-row .money')];
    const parsePrice = v => {
      const allowed = '0123456789.';
      const cleaned = v
        .split('')
        .filter(l => allowed.includes(l))
        .join('');

      return parseFloat(cleaned);
    };

    const totalPrice = priceNodes.reduce((acc, curr) => acc + parsePrice(curr.innerText), 0);
    return totalPrice;
  }

  const setRibbon = subtotal => {
    const shipContent = {
      free: /*html*/`<strong>CONGRATS!</strong> Your order qualifies for <strong>FREE SHIPPING</strong> in the lower 48 states.`,
      paid: /*html*/`Shipping is calculated at checkout.`
    };

    console.log(subtotal);
    const newContent = subtotal > 75 ? shipContent.free : shipContent.paid;
    const ribbonText = document.querySelector('.cart-ribbon-text');
    ribbonText.innerHTML = newContent;
  };

  const setSubtotal = subtotal => {
    const priceStr = '$' + subtotal.toString();
    const priceContainer = document.querySelector('.subtotal-price .money');
    priceContainer.innerText = priceStr;
  }

  const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
  const onQuantityChange = async () => {
    await sleep(1000);
    const subtotal = calculateSubTotal();
    setRibbon(subtotal);
    setSubtotal(subtotal);
  };

  const addQuantityListeners = () => {
    const btns = [...document.querySelectorAll('.qty-box__ctrl')];
    const inps = [...document.querySelectorAll('.qty-box__input')];
    btns.forEach(b => b.addEventListener('click', onQuantityChange));
    inps.forEach(i => i.addEventListener('change', onQuantityChange));
  };

  const init = (() => {
    addQuantityListeners();
  })();
//

})();


(() => {

  const createModal = modal => {
    const overlay = document.createElement('div');
    const classes = ['modal-backdrop', 'fade', 'in'];
    classes.forEach(c => overlay.classList.add(c));
    modal.insertAdjacentElement('afterend', overlay);
    const closeBtn = modal.querySelector('.modal-close');
    closeBtn.addEventListener('click', e => hideModal(overlay, modal));
    document.addEventListener('click', e => detectModalClose(e, overlay, modal));
  };

  const showModal = modal => {
    modal.style.display = 'block';
    createModal(modal);
  };

  const hideModal = (overlay, modal) => {
    modal.style.display = 'none';
    overlay.remove();
  };

  const detectModalClose = ({target}, overlay, modal) => {
    const isBackdrop = target && target.classList.contains('modal');
    if (!isBackdrop) return;
    hideModal(overlay, modal);
  };

  const shippingModalInit = async () => {
    const modal = document.querySelector('.shipping-calculator-modal');
    const shipBtn = document.querySelector('.cart-shipping-rates-btn');
    shipBtn.addEventListener('click', () => showModal(modal));
  };

  const guaranteeModalInit = async () => {
    // cart-row-guarantee
    const modal = document.querySelector('.guarantee-modal');
    const guarBtn = document.querySelector('.cart-row-guarantee');
    if (!modal || !guarBtn) return;
    guarBtn.addEventListener('click', e => {
      e.preventDefault();
      showModal(modal)
    });
  };

  const nortonInit = () => {
    const nortonBtn = document.querySelector('#cart-norton-btn');
    if (!nortonBtn) return;
    nortonBtn.addEventListener('click', () => {
      if (location.href.includes('shopifypreview')) {
        alert('Normally this button would trigger a Norton popup. Norton uses domain validation so this can\'t happen on the preview site.');
        return;
      }

      const nortonBadge = document.querySelector('#buysafeseal_1_a');
      nortonBadge.click();
    });
  };

  const init = (() => {
    shippingModalInit();
    guaranteeModalInit();
    nortonInit();
  })();
})();


(() => {
  const hasCookies = () => 'cookieEnabled' in navigator && navigator.cookieEnabled;

  const cookieChecker = () => {
    if (!hasCookies()) return;
    const message = document.querySelector('.cookie-message');
    if (!message) return;
    message.remove();
  };

  cookieChecker();
})();